/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'svg-shaft2': {
    width: 399.976,
    height: 399.976,
    viewBox: '0 0 105.827 105.827',
    data: '<path pid="0" d="M0 37.545h34.563v30.736H0zM39.417 12.422H66.41v80.983H39.417zM71.264 37.545h34.563v30.736H71.264z"/>'
  }
})
